var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100% - 100px)","background-color":"#27408B"}},[_c('v-container',[_c('v-layout',[_c('h1',{staticClass:"titulo"},[_vm._v("Nosso sol pode salvar o mundo e suas finanças.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }